"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMedium = function IconMedium(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M36.388 9.578c-7.65-6.62-19.184-6.09-26.19 1.268-7.094 7.45-6.97 19.191.277 26.49 7.248 7.3 18.989 7.505 26.488.464s8.033-18.77 1.205-26.464l-1.496 1.328.24.277c5.855 6.885 5.302 17.185-1.318 23.4-6.71 6.3-17.214 6.117-23.7-.414-6.484-6.53-6.595-17.036-.248-23.701 6.346-6.666 16.845-7.07 23.685-.913l1.338-1.486zM29.87 30.88h2.66l-3.4-13.77h-2L24 24.94l-3.1-7.82h-2l-3.43 13.76h2.67l2.11-8.95 2.83 6.9h1.88l2.83-6.9z",
    clipRule: "evenodd"
  })));
};

export { IconMedium, IconMedium as default };
